import { Link } from 'react-router-dom';
import type { Special } from '@/types';
import SectionHeader from '@/components/feature/SectionHeader';
import { formatViews } from '@/utils/format';

export default function HotSpecials({ specials }: { specials: Special[] }) {
  return (
    <section className="w-full px-4 md:px-8 pb-10 md:pb-12">
      <SectionHeader
        title="热门专题"
        subtitle="近期点击率最高的爆料合集与深度报道"
        icon="ri-bookmark-3-line"
        moreTo="/special/s1"
        moreLabel="浏览专题"
      />
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {specials.map((sp) => (
          <Link
            key={sp.id}
            to={`/special/${sp.id}`}
            className="group rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
          >
            <div className="relative w-full aspect-[2/1] overflow-hidden bg-background-200">
              <img src={sp.cover} alt={sp.title} className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500" />
              <span className="absolute left-3 top-3 px-2.5 py-1 rounded-full bg-accent-500 text-background-50 text-xs font-medium">
                {sp.tag}
              </span>
            </div>
            <div className="p-4">
              <h3 className="font-heading text-base font-semibold text-foreground-900 line-clamp-1 group-hover:text-primary-600 transition-colors">
                {sp.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-500 line-clamp-2 leading-relaxed">{sp.intro}</p>
              <div className="flex items-center justify-between mt-3 text-xs text-foreground-400">
                <span className="flex items-center gap-1"><i className="ri-eye-line" /> {formatViews(sp.views)}</span>
                <span className="flex items-center gap-1"><i className="ri-stack-line" /> {sp.articleIds.length} 篇内容</span>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}